import { Card } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiButton from "components/VuiButton";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import useCommon from "hooks/useCommon";
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { getRoles } from "store/slice/rolesSlice";
import HotelSelector from "components/HotelSelector";
import { getUsers } from "store/slice/userSlice";
import UsersTable from "./components/UsersTable";
import AddUserDialog from "./components/AddUserDialog";
import { createUser } from "store/slice/userSlice";
import Snackbar from "components/Snackbar";
import VuiInput from "components/VuiInput";
import { resetCreateUserState } from "store/slice/userSlice";

const Users = () => {
  const { DISPATCH, NAVIFATE, STORE } = useCommon();
  const { list: users, listLoading, listError } = STORE((state) => state.user);

  const [search, setSearch] = useState("");
  const [addUserOpen, setAddUserOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    color: "success",
    title: "",
    content: "",
    icon: "check",
  });

  const showSnackbar = ({ color, title, content, icon = "check" }) => {
    setSnackbar({
      show: true,
      color,
      title,
      content,
      icon,
    });
  };

  const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, show: false }));

  const handleAddUserOpen = () => {
    setAddUserOpen(true);
  };

  const handleAddUserClose = () => {
    setAddUserOpen(false);
    DISPATCH(resetCreateUserState());
  };

  const handleAddUser = async (payload) => {
    // return console.log("payload in create user handler ===>", payload);
    await DISPATCH(createUser(payload))
      .unwrap()
      .then((res) => {
        const success = res?.success;

        if (success) {
          setAddUserOpen(false);
          DISPATCH(resetCreateUserState());
          setSnackbar({
            ...snackbar,
            color: success ? "success" : "error",
            title: success ? "User Created" : "Error",
            content: res?.message || "User created successfully",
            icon: success ? "check" : "warning",
            show: true,
          });
        }
      })
      .catch((err) => {
        // setSnackbar({
        //   ...snackbar,
        //   color: "error",
        //   title: "Error",
        //   content: err?.message || "Failed to create user",
        //   icon: "warning",
        //   show: true,
        // });
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox>
        <VuiBox py={1}>
          <VuiBox mb={3}>
            <Card>
              <VuiBox mb="22px">
                {/* ===== Desktop / Large Screens (md+) ===== */}
                <VuiBox
                  display={{ xs: "none", md: "flex" }}
                  gap={2}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <VuiTypography
                    variant="lg"
                    sx={{
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                    }}
                  >
                    My Users
                  </VuiTypography>

                  <VuiBox display="flex" gap={2} alignItems="center">
                    <HotelSelector />

                    <VuiBox sx={{ width: "200px" }}>
                      <VuiInput
                        gradient
                        fullWidth
                        placeholder="Search users..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </VuiBox>

                    <VuiButton
                      variant="contained"
                      color="primary"
                      onClick={handleAddUserOpen}
                      sx={{ display: "flex", alignItems: "center", gap: "4px" }}
                    >
                      <FaPlus size="12px" />
                      <VuiTypography
                        variant="text"
                        color="white"
                        sx={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Add New
                      </VuiTypography>
                    </VuiButton>
                  </VuiBox>
                </VuiBox>

                {/* ===== Mobile / Small Screens (xs–sm) ===== */}
                <VuiBox display={{ xs: "block", md: "none" }}>
                  <VuiTypography
                    variant="lg"
                    sx={{
                      display: "block",
                      width: "100%",
                      textAlign: "left",
                      mb: 1,
                    }}
                  >
                    My Users
                  </VuiTypography>

                  <VuiBox
                    mt={1}
                    mb={2}
                    sx={{ display: "flex", justifyContent: "center", width: "100%" }}
                  >
                    <HotelSelector minWidth={250} />
                  </VuiBox>

                  <VuiBox display="flex" justifyContent="center" gap={1}>
                    <VuiInput
                      fullWidth
                      placeholder="Search users..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      gradient
                    />

                    <VuiButton
                      variant="contained"
                      color="primary"
                      onClick={handleAddUserOpen}
                      sx={{
                        minWidth: 44,
                        px: 1.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                      }}
                    >
                      <FaPlus size="12px" />
                      <VuiTypography
                        variant="text"
                        sx={{ display: { xs: "none", sm: "block" }, lineHeight: 1 }}
                      >
                        Add New
                      </VuiTypography>
                    </VuiButton>
                  </VuiBox>
                </VuiBox>
              </VuiBox>

              {/* <VuiBox
                mb="22px"
                display="flex"
                flexWrap="wrap"
                gap={2}
                alignItems="center"
                justifyContent="space-between"
              >
                <VuiTypography
                  variant="lg"
                  
                  sx={{
                    width: { xs: "100%", md: "auto" },
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  My Users
                </VuiTypography>

                <VuiBox
                  display="flex"
                  gap={2}
                  alignItems="center"
                  sx={{
                    // width: "100%",
                    // flexDirection: "row",
                    // flexWrap: "nowrap",
                    width: { xs: "100%", md: "auto" },
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: { xs: "center", md: "flex-end" },
                  }}
                >
                  <VuiBox>
                    <HotelSelector />
                  </VuiBox>

                  <VuiBox sx={{ width: { xs: "100%", sm: "220px" } }}>
                    <VuiInput
                      fullWidth
                      placeholder="Search users..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      icon={{
                        component: "search",
                        direction: "left",
                      }}
                    />
                  </VuiBox>

                  <VuiButton
                    variant="contained"
                    color="primary"
                    onClick={handleAddUserOpen}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      width: { sm: "50%", md: "auto" },
                    }}
                  >
                    <FaPlus size="12px" />
                    <VuiTypography
                      variant="text"
                      
                      sx={{ display: { xs: "none", sm: "block" }, lineHeight: 1 }}
                    >
                      Add New
                    </VuiTypography>
                  </VuiButton>
                </VuiBox>
              </VuiBox> */}

              <VuiBox
                sx={{
                  "& th": {
                    borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                      `${borderWidth[1]} solid ${grey[700]}`,
                  },
                  "& .MuiTableRow-root:not(:last-child)": {
                    "& td": {
                      borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                        `${borderWidth[1]} solid ${grey[700]}`,
                    },
                  },
                }}
              >
                <UsersTable handleNotify={showSnackbar} search={search} />
              </VuiBox>
            </Card>
          </VuiBox>
        </VuiBox>
      </VuiBox>

      <Snackbar
        color={snackbar.color}
        icon={snackbar.icon}
        title={snackbar.title}
        content={snackbar.content}
        open={snackbar.show}
        onClose={closeSnackbar}
        close={closeSnackbar}
      />

      {addUserOpen && (
        <AddUserDialog
          open={addUserOpen}
          onClose={handleAddUserClose}
          onSave={(data) => {
            handleAddUser(data);
          }}
        />
      )}
    </DashboardLayout>
  );
};

export default Users;
